module.exports = __webpack_public_path__ + "static/media/LogoWeb.e7f25b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LogoWeb.png
// module id = 1022
// module chunks = 0